// Mock data for God of Cricket website

export const siteInfo = {
  name: "God of Cricket",
  tagline: "GOC",
  subTagline: "God of Cricket",
  address: "123 Cricket Academy Road, Tirupati, Andhra Pradesh 517501",
  email: "info@godofcricket.in",
  phone: "+91 98765 43210",
  instagram: "https://instagram.com/godofcricket"
};

export const navItems = [
  { name: "HOME", href: "#home" },
  { name: "KNOWLEDGE HUB", href: "#articles" },
  { name: "CAREER PATHWAY", href: "#academies" },
  { name: "STATS", href: "#stats" },
  { name: "COACHING", href: "#services" },
  { name: "CONTACT", href: "#contact" }
];

export const aboutContent = {
  title: "About us",
  intro: "Are you ready to embark on a journey to enhance your cricket skills and boost your fitness levels? Welcome to GOC, the premium indoor cricket and fitness facility right in the heart of Tirupati.",
  mission: {
    title: "Our Mission:",
    text: "At GOC, our mission is simple yet powerful: to create an environment where individuals can not only refine their cricket prowess and improve their fitness but also leave feeling invigorated, enlightened, and motivated. We are your dedicated partner in reaching your full potential, whether you're renting our state-of-the-art cricket and fitness facilities or participating in our diverse personal training and cricket programs."
  },
  setsApart: {
    title: "What Sets Us Apart:",
    text: "GOC is more than just a training centre; it's a community of individuals striving for excellence in their chosen disciplines. We are committed to providing an atmosphere where everyone can thrive and prosper. Join us in this God of Cricket Training and unlock your true potential."
  }
};

export const founderMessage = {
  title: "A Message from Our Founder, Captain Aravind:",
  quote: "Cricket is not just a sport, it's a way of life. Every ball you face teaches you patience, every shot you play builds confidence, and every match you lose makes you stronger. The pitch doesn't care about your background - it only rewards hard work, dedication, and the courage to keep going when others give up.",
  highlight: "GOC is more than two indoor cricket training facilities and a boutique fitness studio; it's a place where individuals enter knowing they're about to become better at something",
  continuation: "Whether it's learning a new cricket skill, improving technique, enhancing body composition, boosting speed and strength, or increasing longevity, GOC does it all with a smile on your face. In essence, GOC is a vibrant community of people, both adults and children, pros and beginners, all committed to self-improvement through the God of Cricket Training.",
  closing: "Join the GOC community and redefine your cricket journey. It's time to unlock your true potential with us!",
  founderImage: "https://customer-assets.emergentagent.com/job_cricket-deity/artifacts/cajh8985_WhatsApp%20Image%202026-01-12%20at%2012.48.25.jpeg"
};

export const netPlans = [
  {
    id: 1,
    name: "Net Starter Pass",
    type: "Pay-Per-Session",
    price: "₹200 – ₹400",
    period: "per session",
    description: "Best for trials & casual players",
    features: ["Single session access", "Basic equipment available", "Flexible timing", "No commitment"],
    popular: false,
    color: "gray"
  },
  {
    id: 2,
    name: "Net Regular Plan",
    type: "Monthly",
    price: "₹2,000 – ₹3,500",
    period: "/ month",
    description: "Fixed slot • Shared nets",
    features: ["Monthly access", "Fixed time slot", "Shared practice nets", "Basic coaching tips"],
    popular: true,
    color: "yellow"
  },
  {
    id: 3,
    name: "Net Plus Plan",
    type: "Quarterly",
    price: "₹5,500 – ₹9,000",
    period: "3 months",
    description: "Priority slot booking",
    features: ["3 months access", "Priority booking", "Flexible slot changes", "10% discount on coaching"],
    popular: false,
    color: "blue"
  },
  {
    id: 4,
    name: "Net Pro Plan",
    type: "6 Months",
    price: "₹10,000 – ₹16,000",
    period: "6 months",
    description: "Locked slots • Serious practice",
    features: ["6 months access", "Locked premium slots", "Bowling machine access", "15% discount on coaching"],
    popular: false,
    color: "purple"
  },
  {
    id: 5,
    name: "Net Elite Plan",
    type: "12 Months",
    price: "₹18,000 – ₹28,000",
    period: "12 months",
    description: "Best value • Long-term commitment",
    features: ["Full year access", "VIP slot priority", "All equipment included", "20% discount on coaching", "Free fitness assessment"],
    popular: false,
    color: "gold"
  }
];

export const coachingPlans = [
  {
    id: 1,
    name: "Skill Builder Program",
    type: "Coaching + Nets",
    price: "₹4,000 – ₹6,000",
    period: "/ month",
    description: "Technique & fitness focus",
    features: ["Personal coaching sessions", "Net practice included", "Video analysis", "Fitness guidance", "Weekly progress review"],
    color: "blue"
  },
  {
    id: 2,
    name: "Performance Program",
    type: "Advanced Coaching",
    price: "₹6,000 – ₹8,000",
    period: "/ month",
    description: "Match preparation & corrections",
    features: ["Advanced technique training", "Match simulation", "Mental conditioning", "Diet & nutrition plan", "Monthly performance report", "Access to Breatheflow.live for mental wellness"],
    color: "green",
    popular: true
  }
];

export const netImages = [
  "https://customer-assets.emergentagent.com/job_cricket-deity/artifacts/cajh8985_WhatsApp%20Image%202026-01-12%20at%2012.48.25.jpeg",
  "https://customer-assets.emergentagent.com/job_cricket-deity/artifacts/adocscjg_WhatsApp%20Image%202026-01-12%20at%2012.48.08.jpeg",
  "https://images.unsplash.com/photo-1531415074968-036ba1b575da?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?w=600&h=400&fit=crop"
];

export const galleryImages = [
  "https://images.unsplash.com/photo-1531415074968-036ba1b575da?w=650&h=650&fit=crop",
  "https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?w=650&h=650&fit=crop",
  "https://images.unsplash.com/photo-1580674684081-7617fbf3d745?w=650&h=650&fit=crop",
  "https://images.unsplash.com/photo-1624526267942-ab0ff8a3e972?w=650&h=650&fit=crop",
  "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=650&h=650&fit=crop",
  "https://images.unsplash.com/photo-1594470117722-de4b9a02ebed?w=650&h=650&fit=crop",
  "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=650&h=650&fit=crop",
  "https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=650&h=650&fit=crop",
  "https://images.unsplash.com/photo-1599058945522-28d584b6f0ff?w=650&h=650&fit=crop",
  "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=650&h=650&fit=crop",
  "https://images.unsplash.com/photo-1558611848-73f7eb4001a1?w=650&h=650&fit=crop",
  "https://images.unsplash.com/photo-1517963879433-6ad2b056d712?w=650&h=650&fit=crop"
];

export const testimonials = [
  {
    id: 1,
    text: "Had a really enjoyable 1-2-1 coaching session with Captain Aravind at this lovely facility for all levels of cricketer in Tirupati. Another plus is the option to go on your own to practice with an auto-feed-enabled bowling machine. Captain Aravind is such a friendly guy that I was immediately at ease and he pretty quickly assessed where I could improve my game without information overload. We then spent some time on core physical training in the well-appointed gym upstairs. Great place, expert coaching - will be back!",
    name: "Vikram Patel",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop"
  },
  {
    id: 2,
    text: "So pleased that GOC has opened! This is a great facility and enables my son (who is cricket mad!) to keep up his training, particularly over the monsoon months when it's not possible to play outside. The space is lovely - simple but really well thought out and larger than you expect so there's plenty of space to practise all aspects of cricket. Captain Aravind is a fantastic coach and my son loves his sessions. He comes home every time absolutely buzzing and we can really see him progressing. Will be booking in every holiday for sessions!",
    name: "Priya Mehta",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop"
  },
  {
    id: 3,
    text: "My son had a fantastic session with Captain Aravind @ GOC. Facilities are great for improving technique and S&C tips were well received.",
    name: "Arjun Desai",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop"
  },
  {
    id: 4,
    text: "Really cool net and gym facilities. Great training with Captain Aravind for my son.",
    name: "Ananya Singh",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop"
  }
];

export const services = [
  {
    id: 1,
    title: "Packages",
    description: "Whether you are a cricket club or a school, GOC is the perfect venue to hire for winter nets or pre season training.",
    image: "https://images.unsplash.com/photo-1531415074968-036ba1b575da?w=600&h=600&fit=crop",
    link: "#packages"
  },
  {
    id: 2,
    title: "Personal Training",
    description: "At GOC we understand that every client has a unique set of individual goals, needs and circumstances so therefore we tailor every PT programme.",
    image: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600&h=600&fit=crop",
    link: "#personal-training"
  },
  {
    id: 3,
    title: "Hire Our Facilities",
    description: "Our cricket net and personal training studio can be rented per hour.",
    image: "https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?w=600&h=600&fit=crop",
    link: "#hire"
  },
  {
    id: 4,
    title: "Mental Wellness",
    description: "Enhance your mental game with Breatheflow - guided breathing and mindfulness for peak cricket performance.",
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600&h=600&fit=crop",
    link: "https://breatheflow.live",
    external: true
  }
];

export const heroImages = [
  "https://images.unsplash.com/photo-1531415074968-036ba1b575da?w=1920&h=1080&fit=crop",
  "https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?w=1920&h=1080&fit=crop"
];

export const backgroundImages = {
  hero: "https://images.unsplash.com/photo-1531415074968-036ba1b575da?w=1920&h=1080&fit=crop",
  about: "https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?w=800&h=600&fit=crop",
  mission: "https://images.unsplash.com/photo-1594470117722-de4b9a02ebed?w=800&h=800&fit=crop",
  setsApart: "https://images.unsplash.com/photo-1624526267942-ab0ff8a3e972?w=800&h=800&fit=crop",
  founder: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600&h=800&fit=crop"
};
